//@ts-nocheck
import { useEffect, useState } from "react";
import { toTitleCase } from "../../../utils/functions";

const phoneRegExp =
  /(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/gim;

const DEFAULT_TRIGGERS = {
  phone: {
    triggers: [phoneRegExp],
    isActive: true,
    prompt: "Don't enter a phone number here",
  },
  email: {
    triggers: ["@", "gmail", "yahoo", "icloud", "hotmail"],
    isActive: true,
    prompt: "Don't enter an email here",
  },
  contact: {
    triggers: ["username", "whatsapp", "messenger", "wechat", "skype"],
    isActive: true,
    prompt: "Don't enter any username or chat id here",
  },
  money: {
    triggers: ["payment", "paid"],
    isActive: true,
    prompt: "Don't include any payment information",
  },
  link: {
    triggers: ["www", "http"],
    isActive: true,
    prompt: "Don't insert any links here",
  },
  social: {
    triggers: [
      "facebook",
      "youtube",
      "twitter",
      "linkedin",
      "instagram",
      "snapchat",
      "pinterest",
      "website",
      "github",
      "dribbble",
      "beehance",
    ],
    isActive: false,
    prompt: "Ensure not to enter any links",
  },
  personal: {
    triggers: ["name"],
    isActive: false,
    prompt: "Be careful not to reveal your full name",
  },
};

/**
 * Parses an input string to check for trigger words and returns an
 * error message to the user.
 * @param {String} string Input typed by user
 */
export const parseStringForTriggers = (str = "", triggers = {}) => {
  let string = str || "";
  let trigger = [];
  let titleCase = toTitleCase(string);
  let formattedText = titleCase
    ? titleCase
        .toLowerCase()
        .replace(" ", " ")
        .replace(" ", " ")
        .replace(" ", " ") : "";

  const formattedTriggers = { ...DEFAULT_TRIGGERS, ...triggers };
  Object.entries(formattedTriggers).forEach(([key, value]) =>
    value.triggers.forEach(
      (triggerWord) =>
        formattedText.search(triggerWord) > -1 && trigger.push(key)
    )
  );

  let listOfTriggers = Array.from(new Set(trigger));
  let lastTrigger = listOfTriggers.length > 0 && listOfTriggers.pop();
  let triggerPrompt = lastTrigger ? formattedTriggers[lastTrigger]?.prompt : "";
  let isActiveTrigger = lastTrigger
    ? formattedTriggers[lastTrigger].isActive
    : false;

  return isActiveTrigger ? triggerPrompt : "";
};

export const useStreamingProfileDescription = (
  generator?: () => Generator<Promise<any>, string, any>
) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");
  const [generate, beginGeneration] = useState(false);

  useEffect(() => {
    async function fetchData() {
      if(generator){
        setLoading(true);
        for await (const data of generator()) {
          setText((p) => p + data);
        }
        setLoading(false);
        beginGeneration(false);

      }
    }
    if (generate) {
      fetchData();
    }
  }, [generate]);

  function generateDescription() {
    setText("");
    beginGeneration(true);
  }
  return { loading, text, generateDescription };
};

export const useTextArea = (
  valueProp,
  onChange,
  characterLimit,
  isInvalid,
  parseInput,
  triggers = {},
  streamingText,
  streamingLoading
) => {
  const [value, setValue] = useState(valueProp);
  const charactersLeft = characterLimit ? characterLimit - value.length : 0;
  let t = typeof value === "string" ? value : "";
  const triggerPrompt = parseStringForTriggers(t, triggers);

  const isInvalids = parseInput
    ? isInvalid || charactersLeft < 0 || triggerPrompt
    : isInvalid || charactersLeft < 0;

  useEffect(() => {
    onChange && onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  useEffect(() => {
    if (streamingText && !streamingLoading) {
      setValue(streamingText);
    }
  }, [streamingText, streamingLoading]);

  const handleChange = ({ target }) => {
    setValue(target.value);
  };

  return {
    value,
    isInvalids,
    handleChange,
    triggerPrompt,
    charactersLeft,
    inputCharacters: value.length,
  };
};
